import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  getSendingDomain,
  removeSendingDomain,
  setSendingDomain,
  verifySendingDomain,
  type SendingDomain,
} from '@/api/emailDomain'

const KEY = ['sending-domain']

export function useSendingDomain() {
  return useQuery({ queryKey: KEY, queryFn: getSendingDomain })
}

// All three mutations return the fresh state, so we seed the cache directly (no refetch).

export function useSetSendingDomain() {
  const qc = useQueryClient()
  return useMutation<SendingDomain, unknown, string>({
    mutationFn: (domain) => setSendingDomain(domain),
    onSuccess: (data) => qc.setQueryData(KEY, data),
  })
}

export function useVerifySendingDomain() {
  const qc = useQueryClient()
  return useMutation<SendingDomain, unknown, void>({
    mutationFn: () => verifySendingDomain(),
    onSuccess: (data) => qc.setQueryData(KEY, data),
  })
}

export function useRemoveSendingDomain() {
  const qc = useQueryClient()
  return useMutation<SendingDomain, unknown, void>({
    mutationFn: () => removeSendingDomain(),
    onSuccess: (data) => qc.setQueryData(KEY, data),
  })
}
